<template>
    <div class="expert-help">
        <v-card-text>
            {{$t('HelpExpert.moderator_menu_corresponding')}}
            <br />
            <br>
            {{$t('HelpExpert.columns_moderator_role')}}:<br>
            <span>1. <b>{{$t('HelpExpert.examination')}}</b> – {{$t('HelpExpert.applications_requiring_moderation')}}</span><br>
            <span>2. <b>{{$t('HelpExpert.expert_advice')}}</b> – {{$t('HelpExpert.applications_expert_council')}}</span><br>
            <span>3. <b>{{$t('HelpExpert.completion')}}</b> – {{$t('HelpExpert.applications_​expertise_evision')}} </span><br>
            <span>4. <b>{{$t('HelpExpert.rejected')}}</b> – {{$t('HelpExpert.applications_rejected_you')}}</span>
        </v-card-text>
        <v-img
        max-width="600"
        src="../../../assets/help-expert/pasted image 0.png"></v-img>
        <v-card-subtitle>{{$t('HelpExpert.application_examination_decision')}}</v-card-subtitle>
        <v-img
        max-width="600"
        src="../../../assets/help-expert/pasted imaaage 0.png"></v-img>
        <v-card-subtitle>{{$t('HelpExpert.window_required_direction')}} </v-card-subtitle>
        <v-img
        max-width="600"
        src="../../../assets/help-expert/pasted imagess 0.png"></v-img>
        <v-card-subtitle>{{$t('HelpExpert.attached_pplication_registration')}}</v-card-subtitle>
        <v-img
        max-width="600"
        src="../../../assets/help-expert/pasted imaaasage 0.png"></v-img>
    </div>
</template>
<script>
export default {
    name: 'ExpertHelp'
}
</script>
<style scoped>
.v-image {
    margin-bottom: 40px;
}
</style>